<template>

    <div v-if="show" class="event" :class="{ 'event-expanded' : !isCollapsed }">
        <div class="tick"></div>
        <div class="event-content">
            <div class="event-header" @click.self="isCollapsed = !isCollapsed">
                <div class="d-flex align-items-center" @click="isCollapsed = !isCollapsed">
                    <slot name="title"></slot>
                </div>
                <div class="d-flex align-items-center">
                    <span class="date mr-10" @click="isCollapsed = !isCollapsed">{{ date | relativeTime }}</span>
                    <v-dropdown
                        type="dots"
                        :items="actions"
                        :show-selected="false"
                        :menu-right="true"
                        @change="$emit('action', $event)">
                    </v-dropdown>
                </div>
            </div>
            <div v-if="!isCollapsed" class="event-body">
                <slot name="body"></slot>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .event {
        border-left: 1px solid $color-rule;
        padding: 0 0 10px 10px;
        position: relative;
        .tick {
            background-color: $color-rule;
            border-radius: 50%;
            height: 7px;
            left: 0;
            margin: 24px 0 0 -4px;
            position: absolute;
            top: 0;
            width: 7px;
        }
        &.event-expanded {
            .event-content:hover {
                .event-header {
                    border-bottom-color: $color-rule;
                }
            }
            .event-header {
                border-color: $color-text;
                border-bottom-color: $color-rule;
                border-radius: 5px 5px 0 0;
            }
            .event-body {
                border-color: $color-text;
            }
        }
    }

    .event-content {
        align-items: center;
        &:hover {
            .event-header {
                border-color: $color-text;
            }
        }
    }

    .event-header {
        align-items: center;
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 5px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        padding: 15px 20px;
        .title {
            @include font-medium(14px);
            color: $color-text;
            user-select: none;
        }
        .date {
            @include font-medium(11px);
            color: $color-muted;
            user-select: none;
        }
    }

    .event-body {
        background: #fff;
        border: 1px solid $color-rule;
        border-radius: 0 0 5px 5px;
        border-top: none;
        padding: 15px 20px;
        table {
            @include font-medium(13px);
            width: 100%;
            td {
                height: 24px;
                vertical-align: top;
                word-break: break-all;
                &.key {
                    color: $color-text;
                    width: 40%;
                }
                &.value {
                    color: $color-text;
                    width: 60%;
                }
            }

        }
    }

</style>

<script>

export default {

    props: {
        date: {
            type: Number,
            required: true,
        },
        actions: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            show: true,
            isCollapsed: true,
        }
    },

}

</script>
